import { createFileRoute } from "@tanstack/react-router";

import { RegisterPage } from "@/components/Pages";

export const Route = createFileRoute("/_auth/register")({
  component: RegisterPage,
});
